import Immutable from 'immutable';

const _initState = Immutable.fromJS([]);

export function queryList(status, data) {
    const { code , list } = data;
    return status.set(code, Immutable.fromJS(list));
}
export function getByCode(status, data){
    const { code } = data;
    return status.get( code );
}

const REDUCER_TABLE = {};
REDUCER_TABLE['dictionary.QueryList'] = queryList;
REDUCER_TABLE['dictionary.GetByCode'] = getByCode;

export default {
    REDUCER_TABLE,
    initialState: _initState
};
